import React from 'react';
import { PaginationWrapper, PageButton, CurrentPageButton } from "./PaginationStyle";

const Pagination = ({ currentPage, itemsPerPage, totalItems, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pageButtons = [];
  const pageLimit = 10;

  const startPage = currentPage <= pageLimit ? 1 : currentPage - Math.floor(pageLimit / 2);
  const endPage = startPage + pageLimit - 1 < totalPages ? startPage + pageLimit - 1 : totalPages;

  if (currentPage !== 1) {
    pageButtons.push(
      <PageButton key="start" onClick={() => handleClick(1)}>
        1
      </PageButton>
    );
    pageButtons.push(
      <PageButton key="prev" onClick={() => handleClick(currentPage - 1)}>
        &laquo;
      </PageButton>
    );
  }

  for(let i = startPage; i <= endPage; i++) {
    const Button = i === currentPage ? CurrentPageButton : PageButton;
    pageButtons.push(
      <Button key={i} onClick={() => handleClick(i)}>
        {i}
      </Button>
    );
  }

  if (currentPage !== totalPages) {
    pageButtons.push(
      <PageButton key="next" onClick={() => handleClick(currentPage + 1)}>
        &raquo;
      </PageButton>
    );
    pageButtons.push(
      <PageButton key="end" onClick={() => handleClick(totalPages)}>
        {totalPages}
      </PageButton>
    );
  }

  const handleClick = (page) => {
    onPageChange(page);
  };

  return (
    <PaginationWrapper>
      {pageButtons}
    </PaginationWrapper>
  );
};

export default Pagination;
